import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class FileManagerService
{
	// constructor
	constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string)
	{

	}

	// get folders
	getDirectoryByPath(DirectoryPath?: string)
	{
		return this.http.get(`${this.baseUrl}api/admin/filemanager/filemanager/getDirectoryByPath?Path=${(DirectoryPath ? DirectoryPath : "")}`);
	}

	// get breadcrumb
	getDirectorBreadcrumbs(DirectoryId: string): Observable<[]>
	{
		return this.http.get<[]>(`${this.baseUrl}api/admin/filemanager/filemanager/GetDirectoryBreadcrumbs?Id=${DirectoryId}`);
	}

	// get folders
	getFolders(ParentId?: string, SearchText?: string): Observable<[]>
	{
		return this.http.get<[]>(`${this.baseUrl}api/admin/filemanager/filemanager/getfolders?ParentId=${ParentId}${(SearchText ? "&SearchText=" + SearchText : "")}`);
	}

	// get files in folder
	getFiles(DirectoryId?: string, SearchText?: string): Observable<[]>
	{
		return this.http.get<[]>(`${this.baseUrl}api/admin/filemanager/filemanager/getFiles?DirectoryId=${DirectoryId}${(SearchText ? "&SearchText=" + SearchText : "")}`);
	}

	// get image thumbnail
	getThumbnail(fileId: string): Observable<string>
	{
		return this.http.get<string>(`${this.baseUrl}api/admin/filemanager/filemanager/getThumbnail?FileId=${fileId}`);
	}

	// create folder
	createFolder(name: string, parentId?: string)
	{
		return this.http.post(`${this.baseUrl}api/admin/filemanager/filemanager/createfolder`, { Name: name, ParentId: parentId });
	}

	// delete folder
	deleteFolder(id: string)
	{
		return this.http.post(`${this.baseUrl}api/admin/filemanager/filemanager/deletefolder`, { Id: id });
	}

	// delete selection
	deleteSelection(selection: any[])
	{
		return this.http.post(`${this.baseUrl}api/admin/filemanager/filemanager/deleteselection`, selection);
	}

	// download
	download(fileId: string)
	{
		return this.http.get(`${this.baseUrl}api/admin/filemanager/filemanager/download?FileId=${fileId}`, { responseType: 'blob' });
	}

	// rename folder
	renameFolder(id: string, name: string)
	{
		return this.http.post(`${this.baseUrl}api/admin/filemanager/filemanager/renamefolder`, { Id: id, Name: name });
	}

	// rename file
	renameFile(id: string, name: string)
	{
		return this.http.post(`${this.baseUrl}api/admin/filemanager/filemanager/renamefile`, { Id: id, Name: name });
	}
}